module.exports = __webpack_public_path__ + "media/src/img/payment/sp-b77270762881a5cf70850decf7fdf094.png";